/*
 * Header behaviour, lifted out of sections/header.liquid.
 *
 * It was 19KB of inline script sitting between the header markup and the hero,
 * so the parser stopped to compile all of it before it could reach the first
 * screen. The work itself was never the problem — the IIFE already waited for
 * DOMContentLoaded — so moving it to a deferred asset keeps the execution
 * timing it always had, drops the compile off the critical path, and lets the
 * file be cached once for every page instead of re-sent with each document.
 *
 * The three values Liquid used to bake in are read from #site-header's data-*
 * attributes instead, so one shared file still serves a per-section config.
 */
(function () {
    /* Read from the DOM instead of baked in by Liquid: this file is now one
       cached asset shared by every page, so it cannot carry a section id. The
       attribute is re-read on each init, which is also what lets a theme-editor
       re-render pick up a new id. */
    var SECTION_ID = null;

    function headerEl() {
      return document.getElementById('site-header');
    }
    var teardown = null;

    function init() {
      var header = headerEl();
      if (header) SECTION_ID = header.getAttribute('data-section-id');
      var row = header && header.querySelector('.hdr-row');
      var drawer = document.getElementById('mobile-menu');
      var burger = header && header.querySelector('.hdr-burger');
      if (!header || !row || !drawer || !burger) return;

      if (teardown) teardown();

      /* Hand the drawer from the HTML-level no-flash guard to the CSS state
         machine now that the section's styles have been parsed. */
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'true');

      var sectionRoot = header.closest('.shopify-section') || header.parentElement;
      var scrollTicking = false;
      var fitTicking = false;
      var fitFrame = null;
      var active = true;
      var lastFitSignature = null;
      var scrolled = null;
      var lastFocus = null;

      /* ---- Fit: pick the richest level that actually fits ------------------
         The two clusters are shrink-0 and the links are whitespace-nowrap, so
         each cluster's box IS its natural width even when the pair no longer
         fits — that is what makes them measurable. (row.scrollWidth cannot do
         this job: it is clamped to clientWidth from below, so "fits with N px
         to spare" would never be true and the bar could never re-expand.)
         Each candidate is applied and measured inside one animation frame, so
         nothing is ever painted in a state that does not fit. */
      var LEVELS = ['full', 'tight', 'min', 'compact'];
      var left = row.querySelector('.hdr-left');
      var right = row.querySelector('.hdr-right');
      var logo = row.querySelector('.hdr-logo-img');

      function fit() {
        fitTicking = false;
        fitFrame = null;
        if (!active) return;

        var style = window.getComputedStyle(row);
        // ResizeObserver fires once on subscription, and window load often
        // repeats the same measurement after fonts.ready. Avoid cycling all
        // four states again when none of their inputs changed. Text and logo
        // identity remain inputs so localized or dynamically updated controls
        // keep their measured fit; font completion explicitly invalidates it.
        var signature = [
          row.clientWidth, row.clientHeight, window.innerWidth,
          style.paddingLeft, style.paddingRight, style.columnGap, style.font,
          row.textContent,
          logo && logo.currentSrc, logo && logo.complete,
          logo && logo.naturalWidth, logo && logo.naturalHeight
        ].join('\u0001');
        if (signature === lastFitSignature) return;
        lastFitSignature = signature;

        var available = row.clientWidth
          - (parseFloat(style.paddingLeft) || 0)
          - (parseFloat(style.paddingRight) || 0);
        var gap = parseFloat(style.columnGap) || 0;
        var current = header.getAttribute('data-nav');
        var currentIndex = LEVELS.indexOf(current);

        for (var i = 0; i < LEVELS.length; i++) {
          header.setAttribute('data-nav', LEVELS[i]);
          if (i === LEVELS.length - 1) break;

          var needed = left.getBoundingClientRect().width
            + right.getBoundingClientRect().width
            + gap;

          /* Moving UP to a richer level demands headroom, so a viewport that
             hovers on the limit cannot flip the bar back and forth. */
          var slack = currentIndex !== -1 && i < currentIndex ? 24 : 0;
          if (needed <= available - slack) break;
        }

        /* A menu whose only close control just disappeared must not survive.
           The test is the control itself, not the level name: 'min' also keeps
           the hamburger (it is where the localization pills went), and the
           scroll lock removing the scrollbar resizes this row — which would
           otherwise close the drawer the instant it opened. */
        if (isOpen() && window.getComputedStyle(burger).display === 'none') closeMenu(true);

        /* At 'compact' the nav is display:none and any panel hanging off it goes
           with it — including the click-away listener's only way to be reached.
           Closing here means a window that shrinks past the threshold does not
           leave an invisible open panel behind for the next widening. */
        var navEl = header.querySelector('.hdr-nav');
        if (navEl && window.getComputedStyle(navEl).display === 'none') {
          for (var n = 0; n < subItems.length; n++) {
            if (header.contains(subItems[n])) setSub(subItems[n], false);
          }
        }
      }

      function scheduleFit() {
        if (!active || fitTicking) return;
        fitTicking = true;
        fitFrame = window.requestAnimationFrame(fit);
      }

      function onFontsReady() {
        lastFitSignature = null;
        scheduleFit();
      }

      /* ---- Dropdown panels -------------------------------------------------
         One controller drives BOTH the bar and the drawer: the two differ only
         in how they are laid out, and a second copy of this logic is a second
         place for the open state to drift out of step with aria-expanded. */
      var SUB_TRIGGER = header.getAttribute('data-sub-trigger') || 'hover';
      var SUB_DELAY = parseInt(header.getAttribute('data-sub-delay'), 10);
      if (isNaN(SUB_DELAY)) SUB_DELAY = 140;
      /* Coarse pointers report hover in some browsers and lie about it; the
         pair is what actually identifies a mouse. On anything else the caret
         button is the only way in, which is exactly right for a finger. */
      var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
      var subItems = [];
      var subCloseTimer = null;

      function setSub(item, on) {
        if (!item) return;
        if (on) item.setAttribute('data-open', '');
        else item.removeAttribute('data-open');
        var toggle = item.querySelector('[data-hdr-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      function closeSubs(except) {
        window.clearTimeout(subCloseTimer);
        for (var i = 0; i < subItems.length; i++) {
          if (subItems[i] !== except) setSub(subItems[i], false);
        }
      }

      function subHoverable(item) {
        return SUB_TRIGGER === 'hover' && hoverMQ.matches && header.contains(item);
      }

      function onSubEnter(event) {
        var item = event.currentTarget;
        if (!subHoverable(item)) return;
        closeSubs(item);
        setSub(item, true);
      }

      function onSubLeave(event) {
        var item = event.currentTarget;
        if (!subHoverable(item)) return;
        /* A delay, not an immediate close: the pointer clips the corner of the
           trigger on its way to the second row often enough that closing on the
           first leave event makes the panel feel like it is dodging the cursor. */
        window.clearTimeout(subCloseTimer);
        subCloseTimer = window.setTimeout(function () { setSub(item, false); }, SUB_DELAY);
      }

      function onSubToggle(event) {
        /* The caret is a <button> inside no form, so this is belt and braces —
           but the group-only trigger shares this handler and must not submit
           anything either. */
        event.preventDefault();
        var item = event.currentTarget.closest('[data-hdr-item]');
        if (!item) return;
        var wasOpen = item.hasAttribute('data-open');
        closeSubs(item);
        setSub(item, !wasOpen);
      }

      function onSubFocusOut(event) {
        var item = event.currentTarget;
        /* relatedTarget is null when focus leaves for the browser chrome; that
           is still "gone", so only a target INSIDE the item keeps it open. */
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        setSub(item, false);
      }

      function onSubDocClick(event) {
        if (event.target.closest('[data-hdr-item]')) return;
        closeSubs();
      }

      function onSubKeydown(event) {
        if (event.key !== 'Escape') return;
        var open = document.querySelector('[data-hdr-item][data-open]');
        if (!open) return;
        setSub(open, false);
        var toggle = open.querySelector('[data-hdr-toggle]');
        if (toggle) toggle.focus();
        /* Escape peels ONE layer. stopImmediatePropagation, not stopPropagation:
           the drawer's own Escape handler is registered on this same node in the
           same phase, and plain stopPropagation does not reach a sibling
           listener — one keystroke would close the panel AND the drawer. */
        event.stopImmediatePropagation();
      }

      function bindSubs() {
        subItems = Array.prototype.slice.call(document.querySelectorAll('[data-hdr-item]'));
        for (var i = 0; i < subItems.length; i++) {
          var item = subItems[i];
          item.addEventListener('pointerenter', onSubEnter);
          item.addEventListener('pointerleave', onSubLeave);
          item.addEventListener('focusout', onSubFocusOut);
          var toggle = item.querySelector('[data-hdr-toggle]');
          if (toggle) toggle.addEventListener('click', onSubToggle);
        }
        if (!subItems.length) return;
        /* Retires the CSS-only :focus-within fallback now that a controller owns
           the state — see the note beside that rule. */
        header.setAttribute('data-subs', 'js');
        document.addEventListener('click', onSubDocClick);
        document.addEventListener('keydown', onSubKeydown, true);
      }

      function unbindSubs() {
        window.clearTimeout(subCloseTimer);
        for (var i = 0; i < subItems.length; i++) {
          var item = subItems[i];
          item.removeEventListener('pointerenter', onSubEnter);
          item.removeEventListener('pointerleave', onSubLeave);
          item.removeEventListener('focusout', onSubFocusOut);
          var toggle = item.querySelector('[data-hdr-toggle]');
          if (toggle) toggle.removeEventListener('click', onSubToggle);
        }
        document.removeEventListener('click', onSubDocClick);
        document.removeEventListener('keydown', onSubKeydown, true);
        header.removeAttribute('data-subs');
        subItems = [];
      }

      /* ---- Scroll shadow --------------------------------------------------- */

      function applyScroll() {
        scrollTicking = false;
        var next = window.scrollY > 20;
        if (next === scrolled) return;
        scrolled = next;
        header.classList.toggle('is-scrolled', next);
      }

      function onScroll() {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(applyScroll);
      }

      /* ---- Drawer ---------------------------------------------------------- */

      function focusables() {
        var list = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        return Array.prototype.filter.call(list, function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
      }

      function setBackgroundInert(on) {
        Array.prototype.forEach.call(document.body.children, function (el) {
          /* contains(), not identity: the bar and the drawer must stay live
             however the platform happens to wrap the section. */
          if (el === sectionRoot || el.contains(header) || el.contains(drawer)) return;
          if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;

          if (on) {
            /* Remember what was ours to undo. A third-party widget (Intercom,
               a review app) may already be inert or aria-hidden for its own
               reasons, and clearing that on close would un-hide it. */
            if (!el.hasAttribute('inert')) {
              el.setAttribute('inert', '');
              el.setAttribute('data-hdr-inert', '');
            }
            if (!el.hasAttribute('aria-hidden')) {
              el.setAttribute('aria-hidden', 'true');
              el.setAttribute('data-hdr-hidden', '');
            }
          } else {
            if (el.hasAttribute('data-hdr-inert')) {
              el.removeAttribute('inert');
              el.removeAttribute('data-hdr-inert');
            }
            if (el.hasAttribute('data-hdr-hidden')) {
              el.removeAttribute('aria-hidden');
              el.removeAttribute('data-hdr-hidden');
            }
          }
        });
      }

      function isOpen() {
        return drawer.classList.contains('is-open');
      }

      function openMenu() {
        if (isOpen()) return;
        lastFocus = document.activeElement;
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-open');
        header.setAttribute('data-menu-open', '');
        burger.setAttribute('aria-expanded', 'true');
        setBackgroundInert(true);

        /* On <html>, not <body>: layout/theme.liquid sets overflow-x on <html>
           with !important, and once the root element's overflow is non-visible
           the body's value no longer propagates to the viewport — the old
           body{overflow:hidden} lock was simply a no-op. */
        document.documentElement.style.overflowY = 'hidden';

        /* focus() is ignored while the element is still visibility:hidden, and
           the class that reveals the drawer has not been through style
           resolution yet. Reading a layout property forces that resolution
           now — a requestAnimationFrame would also work in an active tab, but
           not in a throttled one. */
        void drawer.offsetHeight;
        /* The dialog container takes focus, not the first link: focusing a
           link programmatically makes Safari iOS paint its :focus-visible ring,
           which drew a cyan box around HOME every time the menu opened. Screen
           readers still enter the dialog, and the first Tab moves into the
           focus ring below. */
        drawer.focus();
      }

      function closeMenu(silent) {
        if (!isOpen()) return;

        var hadFocus = drawer.contains(document.activeElement);

        /* A panel left open inside the drawer would still be open the next
           time the drawer is — and its click-away listener cannot fire while
           the drawer is hidden. */
        Array.prototype.forEach.call(drawer.querySelectorAll('[data-loc-panel]'), function (panel) {
          panel.hidden = true;
        });
        Array.prototype.forEach.call(drawer.querySelectorAll('[data-loc-trigger]'), function (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        });

        /* Same reasoning for the nav accordions, with one addition: focusables()
           counts only rendered elements, so a group left open would keep its
           children in the drawer's Tab ring the next time it opens even though
           the merchant's default says collapsed. */
        Array.prototype.forEach.call(drawer.querySelectorAll('[data-hdr-item][data-open]'), function (item) {
          setSub(item, false);
        });

        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        header.removeAttribute('data-menu-open');
        burger.setAttribute('aria-expanded', 'false');
        setBackgroundInert(false);
        document.documentElement.style.overflowY = '';

        /* Even a silent close must not strand focus on a now-hidden element:
           the next Tab would restart from the top of the document. */
        if (silent && hadFocus) {
          var fallback = window.getComputedStyle(burger).display !== 'none' ? burger : header.querySelector('.hdr-logo');
          if (fallback) fallback.focus();
        }

        if (!silent) {
          /* Whatever opened the drawer gets focus back; if that was the page
             body (a pointer tap never focuses the button on iOS), the toggle
             is the right landing spot — never nothing. */
          var restore = lastFocus && lastFocus !== document.body && lastFocus.focus ? lastFocus : burger;
          restore.focus();
        }
        lastFocus = null;
      }

      function onBurger() {
        if (isOpen()) closeMenu();
        else openMenu();
      }

      function onKeydown(event) {
        if (!isOpen()) return;

        if (event.key === 'Escape') {
          /* Escape peels ONE layer: an open language/region panel first, the
             drawer only once nothing is stacked on top of it. */
          if (drawer.querySelector('[data-loc-panel]:not([hidden])')) return;
          closeMenu();
          return;
        }

        if (event.key !== 'Tab') return;

        /* The close control lives in the header, outside the dialog, so it is
           added to the ring by hand — otherwise Tab would escape past it into
           the page behind. It goes FIRST because that is where it sits in the
           DOM: with it last, a Tab from the drawer's final link would not be
           recognised as the end of the ring and would leak into browser UI. */
        var ring = [burger].concat(focusables());
        if (!ring.length) return;
        var first = ring[0];
        var last = ring[ring.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (ring.indexOf(document.activeElement) === -1) {
          event.preventDefault();
          first.focus();
        }
      }

      function onDrawerClick(event) {
        if (event.target.closest('a[href]')) closeMenu(true);
      }

      /* Before the drawer's own listeners: onSubKeydown and onKeydown are both
         capture-phase on `document`, and same-node listeners fire in the order
         they were added. Registering the panels first is what lets Escape close
         a panel without also closing the drawer around it. */
      bindSubs();

      burger.addEventListener('click', onBurger);
      drawer.addEventListener('click', onDrawerClick);
      /* Capture phase: the localization snippet also closes its panels on
         Escape, and its listener is registered first — it is inline in the
         header, and this file is deferred, so every inline script on the page
         has already run by the time we get here. Bubbling would let it clear
         the panel before this handler could see it, and one Escape would then
         collapse both layers at once. */
      document.addEventListener('keydown', onKeydown, true);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', scheduleFit, { passive: true });
      window.addEventListener('orientationchange', scheduleFit);
      row.addEventListener('load', scheduleFit, true);

      var observer = null;
      if (window.ResizeObserver) {
        observer = new ResizeObserver(scheduleFit);
        observer.observe(row);
      }

      /* Poppins changes the answer: the fallback face measures differently, so
         a bar that fits at first paint can overflow once the webfont lands. */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(onFontsReady);
        document.fonts.addEventListener('loadingdone', onFontsReady);
      }
      window.addEventListener('load', scheduleFit);

      fit();
      applyScroll();

      teardown = function () {
        active = false;
        if (fitFrame !== null) window.cancelAnimationFrame(fitFrame);
        unbindSubs();
        burger.removeEventListener('click', onBurger);
        drawer.removeEventListener('click', onDrawerClick);
        document.removeEventListener('keydown', onKeydown, true);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', scheduleFit);
        window.removeEventListener('orientationchange', scheduleFit);
        window.removeEventListener('load', scheduleFit);
        row.removeEventListener('load', scheduleFit, true);
        if (document.fonts) document.fonts.removeEventListener('loadingdone', onFontsReady);
        if (observer) observer.disconnect();
        closeMenu(true);
        teardown = null;
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /* The theme editor re-renders a section AFTER DOMContentLoaded has fired;
       without this the whole bar goes dead for the rest of the merchant's
       editing session. */
    document.addEventListener('shopify:section:load', function (event) {
      var el = headerEl();
      if (el && event.detail.sectionId === el.getAttribute('data-section-id')) init();
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail.sectionId === SECTION_ID && teardown) teardown();
    });
  })();
